<template>
  <div
    class="reservation-item ma-1 pt-2 d-flex flex-column"
    :style="{
      'background-image':
        'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(' +
        item.activity.coverImageUrl +
        ')',
    }"
  >
    <v-layout column class="flex-none">
      <v-layout class="activity-name">
        <span class="activity-title mr-2">{{ item.activity.name }}</span>
      </v-layout>

      <v-layout class="mt-1p">
        <span v-if="acceptedDate"
          class="activity-title requested-for">{{ $t(`reservations.estimated_at.${item.reservation.type}`) + acceptedDate }}</span>
        <span v-else
          class="activity-title requested-for">{{ $t(`reservations.requested_for.${item.reservation.type}`) + requestedDate }}</span>
      </v-layout>
      <v-layout wrap justify-space-between>
        <span class="activity-title mt-1p">{{ $t(`activities.reservation_types.${item.reservation.type}`) }}</span>
        <span v-if="totalPax" class="activity-title total-pax mt-1p">
          <v-icon dark>supervisor_account</v-icon>
          <span class="reservation-data mt-1 ml-1">
            {{ totalPax }}
          </span>
        </span>
      </v-layout>
      <span v-if="totalPrice" class="activity-title white--text body-1 font-weight-medium mt-1p mr-auto">
        <span>{{ getPriceString({ amount: totalPrice, currency: baseCurrency.currency }) }}</span>
        <span v-if="showDisplayCurrency" class="show-spaces text--grey"> ({{ getPriceString({ amount: totalPrice, currency: baseCurrency.currency, displayCurrency: displayCurrency }) }})</span>
      </span>
    </v-layout>
    <v-layout align-end justify-space-between class="full-width mt-auto flex-none">
      <v-chip
        label
        :color="activityReservationColorsByStatus[item.reservation.status].background"
        :text-color="activityReservationColorsByStatus[item.reservation.status].text"
        class="ma-2"
      >
        {{ statusText }}
      </v-chip>
      <v-spacer />
      <span class="pa-2">
        <v-btn outlined dark @click="openDetails()" class="detail-btn">{{
          $t("reservations.details")
        }}</v-btn>
      </span>
    </v-layout>
  </div>
</template>

<script>
import { activityReservationColorsByStatus, activityReservationStatus, reservationTypes } from '@/config'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  props: {
    item: { type: Object, required: true },
  },
  data () {
    return {
      moment,
      activityReservationColorsByStatus,
    }
  },
  methods: {
    getTabSectionByStatus (status) {
      if (status === activityReservationStatus.ACCEPTED || status === activityReservationStatus.PENDING) {
        return this.$t('reservations.active')
      } else return this.$t('reservations.completed')
    },
    openDetails () {
      this.$emit('openDetails', this.item)
    },
  },
  computed: {
    ...mapGetters('me', ['getPriceString', 'showDisplayCurrency', 'displayCurrency', 'baseCurrency']),
    statusText () {
      if (this.isRoomService && this.$te('reservations.order_short_status.' + this.item.reservation.status)) {
        return this.$t('reservations.order_short_status.' + this.item.reservation.status)
      } else if (this.$te('reservations.short_status.' + this.item.reservation.status)) {
        return this.$t('reservations.short_status.' + this.item.reservation.status)
      } else if (this.isRoomService && this.$te('reservations.order_status.' + this.item.reservation.status)) {
        return this.$t('reservations.order_status.' + this.item.reservation.status)
      } else {
        return this.$t('reservations.status.' + this.item.reservation.status)
      }
    },
    acceptedDate () {
      return this.item.reservation.acceptedDate
        ? this.moment(this.item.reservation.acceptedDate).add(this.item.reservation.acceptedTime, 'ms').format('DD/MM/YYYY HH:mm')
        : null
    },
    requestedDate () {
      return this.item.reservation.requestedDate
        ? this.moment(this.item.reservation.requestedDate).add(this.item.reservation.requestedTime, 'ms').format('DD/MM/YYYY HH:mm')
        : '--'
    },
    totalPax () {
      return this.item.nominalAttendees.length + this.item.numeralAttendees.reduce((acc, { quantity }) => acc + quantity, 0)
    },
    isRoomService () {
      return this.item.reservation.type === reservationTypes.ROOM_SERVICE
    },
    order () {
      return this.item.order || this.item.pendingOrder
    },
    totalPrice () {
      if (!this.order) return null
      return this.order.orderLines.reduce((acc, oL) => {
        return oL.parentOrderLine ? acc : acc + (oL.price[0].amount * oL.quantity)
      }, 0)
    },
  },
}
</script>

<style lang="scss"> // TODO: Add scoped
.activity-name {
  position: relative;
  max-width: fit-content;
  :first-child {
    background: none;
    font-size: 22px;
    max-width: calc(100% + 10px);
    display: inline-block;
    font-weight: 500;
    padding-right: 0 !important;
    z-index: 1;
  }
  ::after {
    content: '';
    width: calc(100% + 10px);
    height: 100%;
    background-color: var(--v-primary-darken1);
    opacity: 0.4;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
}
</style>

<style lang="scss" scoped>
.reservation-item {
  border-radius: 4px;
  background-size: cover;
  background-position: center center;
  overflow: hidden;
  min-height: calc(100% - 8px);
}
.requested-for {
  font-size: 16px;
  max-width: inherit;
  display: inline-block;
}
.total-pax {
  font-size: 14px;
}
.detail-btn {
  background: rgba(black, 0.5);
}
.mt-1p {
  margin-top: 1px;
}
</style>
